import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { string, number } from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import Plus from '../../../svg/Plus';
import Minus from '../../../svg/Minus';
import styles from './FaqItem.styles';
import marked from 'marked';

const useStyles = makeStyles(styles);

const FaqItem = ({ question, answer, faqNumber }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const classes = useStyles();
  return (
    <Accordion
      square
      className={classes.accordionItem}
      expanded={isExpanded}
      onChange={() =>
        setIsExpanded((prevState) => !prevState)
      }
    >
      <AccordionSummary
        className={classes.accordionHeader}
        expandIcon={isExpanded ? <Minus /> : <Plus />}
      >
        <Typography className={classes.accordionHeaderText}>
          <Typography
            component="span"
            className={classes.faqNumber}
          >
            {`${faqNumber}. `}
          </Typography>
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        className={classes.accordionDetails}
      >
        <Typography
          className={classes.description}
          dangerouslySetInnerHTML={{
            __html: marked(answer),
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

FaqItem.propTypes = {
  question: string,
  answer: string,
  faqNumber: number,
};

export default FaqItem;
